function FICMultilineTextView(props) {
  return <div style={{ whiteSpace: 'pre-line' }}>
    {props.children}
  </div>
}

export default FICMultilineTextView



// WEBPACK FOOTER //
// ./src/common/components/js/FICMultilineTextView.js